import {sample} from 'lodash';
import {useMemo} from 'react';

import {ThemeTypesEnum} from '../../../libs/shared/ui/src/theme/themeTypes';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import inboxNoConversations1Dark from '../../assets/images/dark/inboxNoConversations1.png';
import inboxNoConversations1 from '../../assets/images/inboxNoConversations1.png';
import inboxNoConversations2 from '../../assets/images/inboxNoConversations2.png';
import inboxNoConversations3 from '../../assets/images/inboxNoConversations3.png';

/*
 * Constants.
 */

const inboxNoConversationsImages = [inboxNoConversations1, inboxNoConversations2, inboxNoConversations3];

/*
 * Hooks.
 */

export const useNoConversationsImageSrc = () => {
  const theme = useUserTheme();
  const themeType = theme.type;

  return useMemo(() => {
    if (themeType === ThemeTypesEnum.EXPANDED_DARK) {
      return inboxNoConversations1Dark;
    }

    return sample(inboxNoConversationsImages) ?? inboxNoConversationsImages[0];
  }, [themeType]);
};
